const DeprecClassFormLoading = () => {
  return <p>Loading...</p>
}

export default DeprecClassFormLoading
